import { PendingSection2ItemDto } from '../dto/PendingSection2ItemDto';
import { PendingSection2Item } from '../../../application/domain/entities/PendingSection2Item';

export function mapPendingSection2ItemDtoToEntity(dto: PendingSection2ItemDto): PendingSection2Item {
  return {
    i9FormId: dto.i9FormId,
    firstName: dto.firstName,
    lastName: dto.lastName,
    middleName: dto.middleName,
    ssn: dto.ssn,
    hireDate: dto.hireDate,
    email: dto.email,
    isRemoteI9: dto.isRemoteI9,
    remoteI9Status: dto.remoteI9Status,
    remoteI9Type: dto.remoteI9Type,
    canArchive: dto.canArchive ?? false,
    createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
    dateSent: dto.dateSent ? new Date(dto.dateSent) : undefined,
  };
}
